import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  availability: [],
  rooming: [],
  roomings_assigned: [],
  category: {},
  rooming_status: {},
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {}
};

// getters
const getters = {
  getList: (state, getters, rootState) => type => {
    var aHotels = [];
    for (var i in state.list) {
      if (state.list[i].visible) aHotels[i] = state.list[i];
    }
    return aHotels;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  get_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") return state.list[id];
    return false;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aHotels = [];
    for (var i in state.list) {
      aHotels.push(state.list[i]);
    }
    return aHotels;
  },

  getListKeyId: (state, getters, rootState) => () => {
    return state.list;
  },

  getAvailability: (state, getters, rootState) => {
    return state.availability;
  },

  getRooming: (state, getters, rootState) => {
    return state.rooming;
  },

  getRoomingsAssigned: (state, getters, rootState) => {
    return state.roomings_assigned;
  },

  getCategories: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.category[id];
    return state.category;
  },
  getRoomingStatus: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.rooming_status[id];
    return state.rooming_status;
  }
};

// actions
const actions = {
  loadList({ commit, state }, params) {
    var path =
      "hotel" +
      (typeof params !== "undefined" && typeof params.event !== "undefined"
        ? "/event/" + params.event
        : "");

    var page_options =
      params && params.page_options ? params.page_options : state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    return api.post(path, oParams).then(function(response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
          data[i].num_rooms = {
            a: data[i].num_room_available,
            b: data[i].num_rooms_busy
          };
          data[i].num_rooms_1 = {
            a: data[i].num_rooms_1pax,
            b: data[i].num_roomsbusy1
          };
          data[i].num_rooms_2 = {
            a: data[i].num_rooms_2pax,
            b: data[i].num_roomsbusy2
          };
          data[i].num_rooms_3 = {
            a: data[i].num_rooms_3pax,
            b: data[i].num_roomsbusy3
          };
          data[i].num_rooms_4 = {
            a: data[i].num_rooms_4pax,
            b: data[i].num_roomsbusy4
          };
          data[i].num_rooms_5 = {
            a: data[i].num_rooms_5pax,
            b: data[i].num_roomsbusy5
          };
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "hotel/" + params.id;
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addHotel", data);
      }
    });
  },

  upload(context, data) {
    var hotel = { ...data.data };
    hotel.event_id = data.event ? data.event.id : false;
    var params = data.params;
    var path =
      typeof hotel.id !== "undefined"
        ? "hotel/" + hotel.id + "/update"
        : "hotel/add";
    return api.post(path, hotel).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("addFacility", data);
        return data.id;
      }
    });
  },

  remove(context, params) {
    var path = "hotel/" + params.hotel_id;
    if (params.event_id) {
      path += "/event/" + params.event_id;
    }
    path += "/remove";

    return api.post(path, {}).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("removeHotel", params.hotel_id);
      }
    });
  },

  addRelHotelEvent(context, params) {
    return api
      .post(
        "hotel/" + params.hotel_id + "/event/" + params.event_id + "/addrel",
        {}
      )
      .then(function(response) {
        if (response.status) {
          return true;
        } else {
          throw response.error.message;
        }
      });
  },

  // AVAILABILITY
  loadAvailability({ commit }, params) {
    return api
      .get(
        "hotel/" +
          params.hotel_id +
          "/event/" +
          params.event_id +
          "/availability"
      )
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].num_rooms_1pax =
              data[i].num_rooms_1pax != null
                ? parseInt(data[i].num_rooms_1pax)
                : 0;
            data[i].num_rooms_2pax =
              data[i].num_rooms_2pax != null
                ? parseInt(data[i].num_rooms_2pax)
                : 0;
            data[i].num_rooms_3pax =
              data[i].num_rooms_3pax != null
                ? parseInt(data[i].num_rooms_3pax)
                : 0;
            data[i].num_rooms_4pax =
              data[i].num_rooms_4pax != null
                ? parseInt(data[i].num_rooms_4pax)
                : 0;
            data[i].num_rooms_5pax =
              data[i].num_rooms_5pax != null
                ? parseInt(data[i].num_rooms_5pax)
                : 0;
            data[i].num_rooms_1pax_used =
              data[i].num_rooms_1pax_used != null
                ? parseInt(data[i].num_rooms_1pax_used)
                : 0;
            data[i].num_rooms_2pax_used =
              data[i].num_rooms_2pax_used != null
                ? parseInt(data[i].num_rooms_2pax_used)
                : 0;
            data[i].num_rooms_3pax_used =
              data[i].num_rooms_3pax_used != null
                ? parseInt(data[i].num_rooms_3pax_used)
                : 0;
            data[i].num_rooms_4pax_used =
              data[i].num_rooms_4pax_used != null
                ? parseInt(data[i].num_rooms_4pax_used)
                : 0;
            data[i].num_rooms_5pax_used =
              data[i].num_rooms_5pax_used != null
                ? parseInt(data[i].num_rooms_5pax_used)
                : 0;

            data[i].rooms = parseInt(
              parseInt(data[i].num_rooms_1pax) +
                parseInt(data[i].num_rooms_2pax) +
                parseInt(data[i].num_rooms_3pax) +
                parseInt(data[i].num_rooms_4pax) +
                parseInt(data[i].num_rooms_5pax)
            );
            data[i].rooms_used = parseInt(
              parseInt(data[i].num_rooms_1pax_used) +
                parseInt(data[i].num_rooms_2pax_used) +
                parseInt(data[i].num_rooms_3pax_used) +
                parseInt(data[i].num_rooms_4pax_used) +
                parseInt(data[i].num_rooms_5pax_used)
            );

            data[i].pax =
              parseInt(data[i].num_rooms_1pax) * 1 +
              parseInt(data[i].num_rooms_2pax) * 2 +
              parseInt(data[i].num_rooms_3pax) * 3 +
              parseInt(data[i].num_rooms_4pax) * 4 +
              parseInt(data[i].num_rooms_5pax) * 5;
          }
          if (typeof params.save === "undefined" || params.save) {
            return commit("setAvailability", data);
          } else {
            return data;
          }
        }
      });
  },

  saveAvailability(context, data) {
    var newAvailability = { ...data.data };
    var path =
      "hotel/" + data.hotel_id + "/event/" + data.event_id + "/availability/";
    data.isEdit ? (path += newAvailability.id + "/update") : (path += "add");

    return api.post(path, newAvailability).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return true;
      } else return false;
    });
  },

  removeAvailability(context, data) {
    var id = data.data.id;
    return api
      .post(
        "hotel/" +
          data.hotel_id +
          "/event/" +
          data.event_id +
          "/availability/" +
          id +
          "/remove",
        {}
      )
      .then(function(response) {
        if (response.status) {
          context.commit("removeAvailabilityState", id);
          return true;
        } else return false;
      });
  },

  // ROOMING
  loadRooming({ commit }, params) {
    return api
      .get("team/" + params.team_id + "/event/" + params.event_id + "/rooming")
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          return commit("setRooming", data);
        }
      });
  },

  saveRooming(context, data) {
    var newRooming = { ...data.data };
    var path = "team/" + data.team_id + "/event/" + data.event_id + "/rooming/";
    data.isEdit ? (path += newRooming.id + "/update") : (path += "add");

    return api.post(path, newRooming).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return true;
      } else return false;
    });
  },

  assignRoomingToHotel(context, params) {
    return api
      .post(
        "hotel/" +
          params.hotel_id +
          "/event/" +
          params.event_id +
          "/rooming/assign",
        { rooming_id: params.rooming_id }
      )
      .then(function(response) {
        if (response.status) {
          return true;
        } else return false;
      });
  },

  loadRoomingsAssigned({ commit }, params) {
    return api
      .get(
        "hotel/" + params.hotel_id + "/event/" + params.event_id + "/rooming"
      )
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].num_rooms_1pax = parseInt(data[i].num_rooms_1pax);
            data[i].num_rooms_2pax = parseInt(data[i].num_rooms_2pax);
            data[i].num_rooms_3pax = parseInt(data[i].num_rooms_3pax);
            data[i].num_rooms_4pax = parseInt(data[i].num_rooms_4pax);
            data[i].num_rooms_5pax = parseInt(data[i].num_rooms_5pax);

            data[i].rooms = parseInt(
              parseInt(data[i].num_rooms_1pax) +
                parseInt(data[i].num_rooms_2pax) +
                parseInt(data[i].num_rooms_3pax) +
                parseInt(data[i].num_rooms_4pax) +
                parseInt(data[i].num_rooms_5pax)
            );
            data[i].rooms_used = parseInt(
              parseInt(data[i].num_rooms_1pax_used) +
                parseInt(data[i].num_rooms_2pax_used) +
                parseInt(data[i].num_rooms_3pax_used) +
                parseInt(data[i].num_rooms_4pax_used) +
                parseInt(data[i].num_rooms_5pax_used)
            );
            data[i].pax =
              parseInt(data[i].num_rooms_1pax) * 1 +
              parseInt(data[i].num_rooms_2pax) * 2 +
              parseInt(data[i].num_rooms_3pax) * 3 +
              parseInt(data[i].num_rooms_4pax) * 4 +
              parseInt(data[i].num_rooms_5pax) * 5;
          }

          return commit("setRoomingsAssigned", data);
        }
      });
  },

  changeHotelRooming({ commit }, params) {
    return api
      .post(
        "hotel/" +
          params.hotel_id +
          "/event/" +
          params.event_id +
          "/rooming/" +
          params.rooming_id +
          "/changeassign",
        {}
      )
      .then(function(response) {
        if (response.status) {
          return true;
        } else return false;
      });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  setAvailability(state, data) {
    state.availability = data;
  },

  setRooming(state, data) {
    state.rooming = data;
  },

  setRoomingsAssigned(state, data) {
    state.roomings_assigned = data;
  },

  addHotel(state, hotel) {
    var list = { ...state.list };
    list[hotel.id] = hotel;

    state.list = list;
  },

  removeHotel(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  removeAvailabilityState(state, id) {
    var availability = { ...state.availability };
    delete availability[id];

    state.availability = availability;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     var bFound = true;
    //     for (var k in filters) {
    //       if (item[k] == null) {
    //         bFound = false;
    //         continue;
    //       }
    //       var item_value = typeof item[k] == "object" ? item[k].id : item[k];

    //       // console.log( "ITEM: " + item[k] + " - FILTER: " + filters[k] );
    //       if (
    //         typeof filters[k] === "string" &&
    //         filters[k] != "" &&
    //         item.hasOwnProperty(k)
    //       ) {
    //         var filter = filters[k]
    //           .normalize("NFD")
    //           .replace(/[\u0300-\u036f]/g, "");
    //         var re = new RegExp(filter, "gi");
    //         item_value = item_value
    //           .normalize("NFD")
    //           .replace(/[\u0300-\u036f]/g, "");
    //         if (!item_value.match(re)) {
    //           bFound = false;
    //         }
    //       } else if (
    //         typeof filters[k] != "string" &&
    //         item.hasOwnProperty(k) &&
    //         filters[k] != item_value
    //       ) {
    //         bFound = false;
    //       }
    //     }

    //     list[i].visible = bFound;
    //   }
    // }

    // state.list = list;
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
